import React from "react";
import ContentSquelette from "../layouts/ContentSquelette";
import OffCanvas from "../components/OffCanvas";
import HeadTools from "../components/OffCanvasComponents/HeadTools";
import Navbar from "../components/Navbar";
import Discussion from "../components/Discussion";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import OffCanvasMessages from "../components/OffCanvasComponents/OffCanvasMessages";
import { CritereFiltreProvider } from "../contexts/CriteresFiltreContext";

export default function HomePage() {
  return (
    <>
      <DisplayDiscussionForMiniScreenProvider>
        <Navbar />
        <ContentSquelette>
          <CritereFiltreProvider>
            <OffCanvas
              panel="Messages"
              headRight={<HeadTools page="Messages" />}
            >
              <OffCanvasMessages />
            </OffCanvas>
            <Discussion />
          </CritereFiltreProvider>
        </ContentSquelette>
      </DisplayDiscussionForMiniScreenProvider>
    </>
  );
}
